const { loginSubscriptions } = require('../subscriptions/loginSubscription'),
    { signUpSubscriptions } = require('../subscriptions/signUpSubscriptions'),
    { guestSubscriptions } = require('../subscriptions/guestSubscriptions'),
    { dashboardSubscriptions } = require('../subscriptions/dashboardSubscriptions'),
    { flightSubscriptions } = require('../subscriptions/flightSubscriptions'),
    { hotelSubscriptions } = require('../subscriptions/hotelSubscriptions'),
    { railSubscriptions } = require('../subscriptions/railSubscriptions'),
    { xtraaSubscription } = require('../subscriptions/xtraaSubscription');

function subscriptionsInit() {
    loginSubscriptions();
    signUpSubscriptions();
    guestSubscriptions();
    dashboardSubscriptions();
    flightSubscriptions();
    hotelSubscriptions();
    railSubscriptions();
    xtraaSubscription()
}

module.exports = { subscriptionsInit };